<div [@fadeIn]="">
    <br/>
    @if (!popupMode) {
        <a mat-button class="goBack" (click)="goBack()">
            <mat-icon>keyboard_arrow_left</mat-icon>
            {{ 'account.back' | transloco }}
        </a>
    }

    <div fxLayout="row" class="inline-flex flex-lt-md-col" fxLayoutAlign="center">
        <mat-card (click)="navigateTo(EnumStudioType.SIGN_STUDIO)" class="start-card">
            <mat-card-header>
                <mat-card-title>
                    <h1>
                        <mat-icon>noise_aware</mat-icon>
                        SignStudio
                        <span class="lower2">({{ 'account.recommended' | transloco }})</span>
                    </h1>
                </mat-card-title>
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content>
                <ul>
                    <li>{{ 'account.webPreviewAndDesktop2' | transloco }}</li>
                    <li>{{ 'account.simpleToUse2' | transloco }}</li>
                    <!--                    <li>{{'account.lotsOfFreeContent' | transloco}}</li>-->
                </ul>
                <div class="img-wrapper">
                    <img (click)="openDialogPreview($event,null,EnumStudioType.SIGN_STUDIO)" [src]="'./assets/images/LiteIconv2.png'"/>
                </div>
                <a color="warn" class="create-account" (click)="navigateTo(EnumStudioType.SIGN_STUDIO)" mat-button style="width: 100%">
                    <mat-icon>noise_aware</mat-icon>
                    <span>{{ 'account.createAccountNow' | transloco }}</span>
                </a>
            </mat-card-content>

        </mat-card>
        <mat-card (click)="navigateTo(EnumStudioType.PRO)" class="start-card">
            <mat-card-header>
                <mat-card-title>
                    <h1>
                        <mat-icon>view_cozy</mat-icon>
                        LegacyStudio
                    </h1>
                </mat-card-title>
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content>
                <ul>
                    <li>{{ 'account.previousStudioVersion2' | transloco }}</li>
                    <li>{{ 'account.highLearningCurve' | transloco }}</li>
                    <!--                    <li>{{'account.desktopBased4' | transloco}}</li>-->
                    <!--                    <li>{{'account.advancedFunc' | transloco}}</li>-->
                    <!--                    <li>{{'account.featureComplete' | transloco}}</li>-->
                </ul>
                <div class="img-wrapper">
                    <img (click)="openDialogPreview($event,null,EnumStudioType.PRO)" mat-card-image [src]="'./assets/images/ProIconv2.png'"/>
                </div>
                <a color="warn" class="create-account" (click)="navigateTo(EnumStudioType.PRO)" mat-button>
                    <mat-icon>view_cozy</mat-icon>
                    <span>{{ 'account.createAccountNow' | transloco }}</span>
                </a>
            </mat-card-content>
        </mat-card>
    </div>
</div>
